import React from "react";

//MUI imports
import { DialogContent, DialogTitle } from '@mui/material';
import Dialog from "@mui/material/Dialog";

import NoteAddIcon from '@mui/icons-material/NoteAdd';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import CloseIcon from '@mui/icons-material/Close';
import Tooltip from '@mui/material/Tooltip';

//Custom components
import AddComprobante from '../../../../ventas/facturacion/AddComprobante';
import Slide from "@mui/material/Slide";

const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
});

function NewInvoiceDialog({ dataCliente, closeNewInvoiceDialog, openNewInvoice }) {
    return (
        <div>
            <Dialog fullScreen open={openNewInvoice} onClose={closeNewInvoiceDialog}
                TransitionComponent={Transition}
            >
                <AppBar sx={{ position: 'relative' }}>
                    <Toolbar sx={{ backgroundColor: "#164e63", color: "white" , width: "97.5%"}}>
                        <Typography sx={{ ml: 2, flex: 1 }} variant="h6" component="div">
                            <NoteAddIcon sx={{ mr: 1, mb: -0.5 }} />
                            Nuevo Comprobante
                        </Typography>
                        <Tooltip title="Cerrar">
                            <IconButton
                                edge="end"
                                color="inherit"
                                onClick={closeNewInvoiceDialog}
                                aria-label="close"
                            >
                                <CloseIcon />
                            </IconButton>
                        </Tooltip>
                    </Toolbar>
                </AppBar>
                <DialogContent sx={{ padding: 0 }}>
                    <AddComprobante dataCliente={dataCliente} closeNewInvoiceDialog={closeNewInvoiceDialog} />
                </DialogContent>
            </Dialog>
        </div>
    )
}

export default NewInvoiceDialog
